/**
 * 检测模块API
 */
import http from './http.js';

export default class CheckApi {
	//启动检测
    static start (params) {
        return http.httpPost('check/start', params);
    }
    static startRC (params) {
        return http.httpPost('check/startRC', params);
    }
    static startOther (params) {
        return http.httpPost('check/startOther', params);
    }
    // PK: 启动诊断
    static startPK (params) {
        return http.httpPost('check/startPK', params);
    }
    // PK: 设置结果
    static pkResult (id) {
        return http.httpPost('check/pkResult', {id});
    }
    // 获取诊断项分类
    static getClassify () {
        return http.httpGet('check/classify');
    }
    //获取检测进度
    static getProgress (token) {
        return http.httpGet('check/getProgress', {
            token: token,
            rc: 1
        });
    }
    //获取检测结果数据
    static getListData (token) {
        return http.httpGet('check/getListData', {
            token: token
        });
    }
    //获取单个检查项数据
    static getItemData (token, id) {
        return http.httpGet('check/getItemData', {
            token: token,
            id: id
        })
    }
    //手工加分
	static recoverScore (token, item) {
        return http.httpPost('check/recoverScore', {
        	token: token,
			item: item
		});
	}
    //取消检测
    static cancel (token) {
        return http.httpPost('check/cancel', {
            token: token
        });
    }
    //验证是否在检测黑名单中
    static hascheckblack (url) {
        return http.httpGet('check/hascheckblack', { url });
    }
    //获取排队情况
    static getQueueUp () {
        return http.httpGet('check/getQueueUp');
    }
    //获取网站指数
    static getWebIndex(token, score) {
        return http.httpGet('check/getWebIndex', {token, score});
    }
    //获取所有页面数
    static getPageNumber() {
        return http.httpGet('check/getPageNumber');
    }
    //生成报告
    static hasCreateReport() {
        return http.httpGet('check/hasCreateReport');
    }
    //获取报告PDF
    static getReportPDF(userId, token, isDownload) {
        isDownload = isDownload ? 1 : 0;
        return http.getBaseUrl() + '/check/getReportPDF?userId=' + userId + '&token=' + token + '&d=' + isDownload;
    }
    // 获取所属企业诊断最多的网站
    static getMostCheckResult() {
        return http.httpGet('check/morest');
    }
    // 获取所属企业组历史诊断过的网站
    static getWebSiteNum() {
        return http.httpGet('check/getWebSiteNum');
    }
    // 获取所属企业组历史诊断网站详情数据
    static getResultByUrlInGroup(token) {
        return http.httpGet('check/groupUrlResult', {token});
    }
}



// WEBPACK FOOTER //
// ./app/api/check.api.js